var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parties"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('PartiesTable',{on:{"create-party":_vm.onCreateParty,"edit-party":_vm.onEditParty}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }